import { Pipe, PipeTransform } from '@angular/core';
import { RoundingHelper } from '../rounding/rounding-helper';

@Pipe({name: 'fancyNumber'})
export class FancyNumberPipe implements PipeTransform {
    public transform(val: number, ctx: any): string {
        if (val === 0) {
            return '0';
        }
        if (!ctx) {
            return '' + val;
        }
        let result = val;
        if (ctx.cap) {
            ctx.cap = Math.abs(ctx.cap);
            if (result > ctx.cap) {
                result = ctx.cap;
            } else if (result < -ctx.cap) {
                result = -ctx.cap;
            }
        }
        let roundTo: number;
        let scale: number;
        if (ctx.roundTo === 'auto' || ctx.scale === 'auto') {
            let roundingSettings = RoundingHelper.CalcRoundingSettingsForNum(val);
            if (ctx.roundTo === 'auto') {
                roundTo = roundingSettings.roundTo;
            } else {
                roundTo = ctx.roundTo;
            }
            if (ctx.scale === 'auto') {
                scale = roundingSettings.scale;
            } else {
                scale = ctx.scale;
            }
        } else {
            roundTo = ctx.roundTo;
            scale = ctx.scale;
        }
        if (Number.isFinite(scale)) {
            result /= scale;
            roundTo /= scale;
        }
        if (Number.isFinite(roundTo)) {
            if (ctx.use2stepRounding && Math.abs(result / roundTo) < 25) {
                roundTo /= 10;
            }
            result /= roundTo;
            result = Math.round(result);
            result *= roundTo;
        }
        let suffix = '';
        if (Number.isFinite(scale) && scale != 1) {
            if (scale === 1.0/1000000) {
                suffix = 'E-6';
            } else if (scale === 0.01) {
                suffix = '%';
            } else if (scale === 1000) {
                suffix = 'k';
            } else if (scale === 1000000) {
                suffix = 'm';
            } else {
                suffix = 'b';
            }
        }
        let leadingPlus = '';
        if (ctx.showPlusForPositive) {
            leadingPlus = result > 0 ? '+' : '';
        }
        let formatter = new Intl.NumberFormat();
        return leadingPlus + formatter.format(result) + suffix;
    }

    public static createDefaultContext(): any {
        return {
            roundTo: 1,
            showPlusForPositive: false,
            cap: undefined,
            scale: undefined,
            use2stepRounding: true,
        };
    }
}